<template>
	<div class="quicklink">
		<ul>
			<li class="mb10" v-for="(item,index) in quickData" v-if="index<8 && !isShow">
				<router-link :to="item.linkAddress"  v-if="item.id<10">{{item.linkName}}</router-link>
				<a :href="item.linkAddress" target="_blank"  v-if="item.id>9">{{item.linkName}}</a>
			</li>
			<li class="mb10" v-for="(item,index) in quickData" v-if="index>7 && isShow">
				<router-link :to="item.linkAddress"  v-if="item.id<10">{{item.linkName}}</router-link>
				<a :href="item.linkAddress" target="_blank"  v-if="item.id>9">{{item.linkName}}</a>
			</li>
		</ul>
		<a v-if="quickData.length>8 && !isShow" class="fr" @click="showMore">更多>></a> 
		<a v-if="quickData.length>8 && isShow" class="fr" @click="showMore">返回>></a> 
	</div>
</template>

<script>
	export default{
		name:'quicklink',
		data(){
			return{
				quickData:[
					{id:1,linkName:"法律法规库",linkAddress:"/applicationTool-fgbzss"},
					{id:2,linkName:"健康知识百科",linkAddress:"/applicationTool-zsbk"},
					{id:3,linkName:"体检项目查询",linkAddress:"/applicationTool-PCUIquery"},
					{id:4,linkName:"化学品类别查询",linkAddress:"/applicationTool-hxlb"},
		    		{id:5,linkName:"危害因素限值查询",linkAddress:"/applicationTool-whysxzcx"},
					{id:6,linkName:"防护用品查询",linkAddress:"/applicationTool-hxfh"},
					{id:7,linkName:"警示标识设置查询",linkAddress:"/applicationTool-jsbz"},
					{id:8,linkName:"工人接触噪声计算",linkAddress:"/applicationTool-zsgj"},
					{id:10,linkName:"社区",linkAddress:"http://bbs.51zyj.com/"},
					{id:9,linkName:"体检报告",linkAddress:"/applicationTool-tjjg"},
					{id:11,linkName:"MSDS查询",linkAddress:"http://msds.anquan.com.cn/"},
				],
				isShow:false
			}
		},
		methods:{
			showMore(){
				this.isShow = !this.isShow;
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/quickLink/index.vue